import styled from "styled-components"
import { RESULT_STYLED_PROPS } from "./interface"
import { colors } from "../../lib/colors"

export const ResultText = styled.p<RESULT_STYLED_PROPS>`
  font-size: 20px;
  position: absolute;
  width: 100%;
  text-align: center;
  line-height: 1;
  text-transform: none;
  display: flex;
  align-items: center;
  justify-content: center;
  top: ${({ isTop }) => (isTop ? "-178px" : "-35px")};
  ${({ fadeIn }) =>
    fadeIn
      ? "opacity: 1; transform: translateY(0px);"
      : "opacity: 0; transform: translateY(10px)"};
  color: ${({ isWin }) =>
    isWin ? colors.secondary : colors.secondaryBackground};
  transition-duration: ${({ fadeIn }) => (fadeIn ? "0.3s" : "0.167s")};
  transition-timing-function: linear;
  transition-property: opacity, transform;
  svg {
    margin-left: 5px;
    height: 16px;
    width: 16px;
    path {
      fill: ${({ isWin }) =>
        isWin ? colors.secondary : colors.secondaryBackground};
    }
  }
`
